import { createSlice } from "@reduxjs/toolkit";
import { getAllProducts, getOneProduct, getAllOrders } from "./thunk";

const initialState = {
  products: [],
  oneProduct: null,
  myOrders: [],
  loading: false,
  error: null,
};

const productSlice = createSlice({
  name: "productSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // ✅ GET ALL PRODUCTS
    builder
      .addCase(getAllProducts.pending, (state) => {
        state.loading = true;
        state.products = [];
        state.error = null;
      })
      .addCase(getAllProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload;
      })
      .addCase(getAllProducts.rejected, (state, action) => {
        state.loading = false;
        state.products = [];
        state.error = action.error.message;
      });

    // ✅ GET ONE PRODUCT
    builder
      .addCase(getOneProduct.pending, (state) => {
        state.loading = true;
        state.oneProduct = null;
        state.error = null;
      })
      .addCase(getOneProduct.fulfilled, (state, action) => {
        state.loading = false;
        state.oneProduct = action.payload;
      })
      .addCase(getOneProduct.rejected, (state, action) => {
        state.loading = false;
        state.oneProduct = null;
        state.error = action.error.message;
      });
    // ✅ GET ONE PRODUCT
    builder
      .addCase(getAllOrders.pending, (state) => {
        state.loading = true;
        state.myOrders = null;
        state.error = null;
      })
      .addCase(getAllOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.myOrders = action.payload;
      })
      .addCase(getAllOrders.rejected, (state, action) => {
        state.loading = false;
        state.myOrders = null;
        state.error = action.error.message;
      });
  },
});

export default productSlice.reducer;